import { List, InputItem, Toast, ActivityIndicator, Button } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import styles from './editSubject.module.scss';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';
import backBtn from '../../static/icon/back_button.png';
import { Dialog } from "antd-mobile-v5";
import { ExclamationCircleOutline } from "antd-mobile-icons";
const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});


function EditSubject(props: any) {
    //输入error
    const [inputError, setInputError] = useState<boolean>(false);
    const [inputError2, setInputError2] = useState<boolean>(false);
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //患者姓名
    const [name, setName] = useState<any>();
    //患者手机号
    const [mobile, setMobile] = useState<any>();
    //受试者编码
    const [subjectCode, setSubjectCode] = useState<any>();
    //受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;

    useEffect(() => {
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');
        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
    }, [])
    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {
        
        //设置网页title
        document.title = `修改${targetName}信息`

        const subJectCode = props.match.params.subjectCode
        if(subJectCode){
            setSubjectCode(subJectCode)
            api.getSubjectdDetail({ id: props.match.params.subjectCode }).then(res => {
                const { code, data } = res;
                if(code == "0"){
                    setMobile(data?.mobile);
                    setName(data?.subjectName)
                }
            })
        }
    }, [])

    //验证输入规则是否符合正则标准
    const checkInputFormat = (value: any) => {
        const checkPhoneRegex = /^1[3-9]\d{9}$/;
        if (!checkPhoneRegex.test(value)) {
            setInputError(true);
          } else {
            setInputError(false);
          }
    }
    //验证输入规则是否符合正则标准
    const checkInputFormat2 = (value: any) => {
        const checkPhoneRegex = /^([A-Z]|-){4,10}$/;
        if (!checkPhoneRegex.test(value)) {
            setInputError2(true);
          } else {
            setInputError2(false);
          }
    }

    //添加提交
    const onSave = () => {
        setLoading(true);

        let isValid = true;
        const regex = /^1[3-9]\d{9}$/;
        

            if(!mobile){
                Toast.fail('手机号不能为空！', 1);
                isValid = false;
                
            }else if(!name){
                Toast.fail('姓名缩写不能为空！', 1);
                isValid = false;
            }else if(!regex.test(mobile)){
                Toast.fail('请填写正确的手机号码!', 1);
                isValid = false;
            }else if(!/^([A-Z]|-){4,10}$/.test(name)){
                Toast.fail('姓名缩写仅支持4-10位大写字母格式或者“-”', 1);
                isValid = false;
            }
            if(!isValid){
                setLoading(false);
                return false
            }
            const params = {
                subjectCode,
                mobile,
                name
            }

            api.updateSubject(params).then(res => {
                if (res.code == '0') {
                    Toast.success('修改成功！', 1);
                    props.history.go(-1);
                    
                }
                else {
                    Toast.fail(res.message, 1);
                    setLoading(false);
                }
            })

    }
    const tooltipContent = (
        <div>
            姓名缩写填写规则：支持4-10位大写字母格式填写姓名缩写；<br/>
            两字姓名填写两字拼音前两个大写字母<br/>
            举例：张悦ZHYU;<br/>
            三字姓名填写三字首字母及第三字第二字母<br/>
            举例：刘书明LSMI<br/>
            四字姓名填写每一个字的首字母<br/>
            举例：上官文朔SGWS<br/>
            如果按以上规则仍无法取得四位姓名缩写时，则用“-”在最后补齐四位姓名缩写<br/>
            举例：王丽娥WLE-<br/>
            四字以上姓名可以填写每一个字的首字母（最多支持十位）<br/>
            举例：博尔济吉特琦善BEJJTQS。
        </div>
    
    );
    return (
        <div className={styles.editSubject_content}>
            <div className={styles.form_content}>
                <div className={styles.formItem}>
                    <div className={styles.title}>
                        &ensp;修改{targetName}信息
                    </div>

                    { 
                        <>
                        <div className={styles.field} >
                            <InputItem
                                clear
                                value={mobile}
                                type="number"
                                onChange={(value) => { setMobile(value);checkInputFormat(value)  }}
                                error={inputError}
                                onErrorClick={() => { Toast.info('请输入正确的手机号！'); }}
                                maxLength={11}
                            >
                               <span className={styles.necessary}>*</span>手机号
                            </InputItem>
                        </div>
                        <div className={styles.field} >
                            <InputItem
                                clear
                                value={name}
                                onChange={(value) => { setName(value);checkInputFormat2(value)  }}
                                error={inputError2}
                                onErrorClick={() => { Toast.info('请输入4到10个大写英文字母！'); }}
                                maxLength={10}
                            >
                              <span className={styles.necessary}>*</span>姓名缩写
                              <ExclamationCircleOutline  onClick={() => {
                                    Dialog.alert({
                                        content: tooltipContent,
                                        closeOnMaskClick: true,
                                    })
                               }} />
                            </InputItem>
                        </div>
                    </>
                    }
                  
                </div>
            </div>
            <div className={styles.save_content}>
                <Button className={styles.save_btn} type="primary" disabled={loading} onClick={onSave} loading={loading}>修改</Button>
            </div>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

            {/* 操作按钮 */}
            <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                <img src={backBtn} alt="back" onClick={() => { props.history.go(-1) }} />
            </div>

        </div>
    )

}

export default EditSubject;